<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<div v-if="onePs.is_linkedin_employees_fetch != 1" class="sloader"></div>
		<div
			v-else-if="onePs.employees"
			v-on:click="handleClick"
			class="flex justify-center items-center"
			style="height: 100%"
		>
			<vx-tooltip text="Contact LinkedIn" placement="top">
				<feather-icon
					icon="Share2Icon"
					class="m-0 cursor-pointer"
					:style="{ color: onePs.employees_sent ? 'green' : '#0a66c2' }"
				/>
			</vx-tooltip>
		</div>
		<div v-else>-</div>
	</div>
</template>
  
  <script>
import Vue from "vue";
import LinkedinInfoPopup from "../LinkedinInfoPopup.vue";
export default {
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			onePs: {},
		};
	},
	created() {
		this.onePs = this.params.data;
	},
	methods: {
		handleClick() {
			this.displayLinkedinInfo(this.onePs.id, this.onePs.url);
		},
		/**
		 * Popup Issues Details
		 * @param {Number} pid - prospect Id
		 * @param {String} url - prospect url
		 */
		displayLinkedinInfo(pid, url) {
			let ComponentClass = Vue.extend(LinkedinInfoPopup);
			let radarChartPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					prospectId: pid,
					prospect_url: url,
				},
			});
			radarChartPopup.$mount();

			this.$refs.popupContainer.appendChild(radarChartPopup.$el);
		},
	},
};
</script>
  
  <style scoped>
/* Optional styling */
</style>